export default ({ request }) => ({
  masterFabricSeriesEcomList(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/ecomList',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesReviewList(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/reviewList',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesReview(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/review',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesDetail(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/detail',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesEcomSave(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/ecomSave',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesReject(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/reject',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesEcomDel(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/ecomDel',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesSubmit(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/submit',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesBindFabric(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/bindFabric',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesRemoveFabric(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/removeFabric',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesImageListApi(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/image/list',
      method: 'POST',
      data,
    })
  },
  masterFabricSeriesImageUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/image/upload',
      method: 'POST',
      data,
    })
  },
  masterFabricSeriesImageSetDefaultApi(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/image/setDefault',
      method: 'POST',
      data,
    })
  },
  masterFabricSeriesImageDelApi(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/image/del',
      method: 'POST',
      data,
    })
  },
  masterFabricSeriesImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/digitalCenter/masterFabricSeries/image/updateSortOrder',
      method: 'POST',
      data,
    })
  }
})
